import React, { useState, useEffect } from 'react';
import './ApplicantTraining.css';
import { Link } from 'react-router-dom';
import Footer from '../../../Footer';
import { GUIDES_CONTENT } from '../../../Console/components/Guides/GuidesContents';
import careerIcon from '../../../../assets/Pages/Career/careerIcon.png';

const ApplicantTraining = () => {
  const [expandedSections, setExpandedSections] = useState({});
  const [sectionProgress, setSectionProgress] = useState({});
  const [showExam, setShowExam] = useState(true);

  const toggleSection = (section) => {
    setExpandedSections((prev) => {
      return Object.assign({}, prev, { [section]: !prev[section] });
    });
  };

//   useEffect(() => {
//     var newProgress = {};
//     var visitedModules = JSON.parse(localStorage.getItem('visitedModules')) || [];

//     function calculateProgress(title, concepts) {
//       var total = concepts.length;
//       var completed = concepts.filter(function (mod) {
//         return visitedModules.includes(mod.detailKey);
//       }).length;
//       return { completed: completed, total: total };
//     }

//     GUIDES_CONTENT.forEach(function (section) {
//       newProgress[section.title] = calculateProgress(section.title, section.coreConcepts);
//     });

//     setSectionProgress(newProgress);

//     var allCompleted = GUIDES_CONTENT.every(function (section) {
//       return section.coreConcepts.every(function (mod) {
//         return visitedModules.includes(mod.detailKey);
//       });
//     });

//     setShowExam(allCompleted);
//   }, []);

  const handleModuleClick = function (detailKey) {
    var visitedModules = JSON.parse(localStorage.getItem('visitedModules')) || [];
    if (!visitedModules.includes(detailKey)) {
      visitedModules.push(detailKey);
      localStorage.setItem('visitedModules', JSON.stringify(visitedModules));
    }
  };

  const visitedModules = JSON.parse(localStorage.getItem('visitedModules')) || [];

  return (
    <div>
      <div className='career-background-one-container'>
        <div className='container'>
          <div className='applicant-training-dashboard-container'>
            <img className='career-page-icon' src={careerIcon} alt="Careers at Pawsible" />
            <h2 className='career-page-heading'>Pawsible: Applicant Onboarding</h2>
            <p className='career-page-paragraph'>
              Begin your journey with Pawsible by completing the onboarding modules below. Turn your passion for pets into a meaningful career.
            </p>

            {GUIDES_CONTENT.map(function (section) {
              var progress = sectionProgress[section.title] || { completed: 0, total: 0 };
              return (
                <div className="training-section" key={section.title}>
                  <div className="training-section-title" onClick={function () { toggleSection(section.title); }}>
                    {section.title}
                    <div className="training-progress-bar-wrapper">
                      <div className="training-progress-bar" style={{ width: (progress.completed / progress.total * 100) + '%' }}></div>
                    </div>
                    <div className="training-progress-label">
                      {progress.completed}/{progress.total} completed
                    </div>
                  </div>
                  {expandedSections[section.title] ? (
                    <div className="training-module-grid">
                      {section.coreConcepts.map(function (mod, index) {
                        var isCompleted = visitedModules.includes(mod.detailKey);
                        return (
                          <Link to={`/console/guides/${mod.detailKey}`} key={index} className="training-module-card-link" onClick={() => handleModuleClick(mod.detailKey)}>
                            <div className={`training-module-card ${isCompleted ? 'completed' : 'not-started'}`}>
                              <div className="training-module-title">{mod.title}</div>
                              <div className={`training-status-badge ${isCompleted ? 'status-completed' : 'status-not-started'}`}>{isCompleted ? 'completed' : 'not started'}</div>
                            </div>
                          </Link>
                        );
                      })}
                    </div>
                  ) : null}
                </div>
              );
            })}

            {showExam && (
              <div className="training-section exam-section">
                <div className="training-section-title">📝 Ready for the Exam?</div>
                <p className="training-module-desc">
                  You've completed all onboarding modules. You're now eligible to take the applicant exam.
                </p>
                <div className='exam-button-container'>
                    <Link to="/exam-form" className="exam-button">Take the Exam</Link>
                </div>
              </div>
            )}

            <div className="training-section">
                <div className="training-section-title">🎓 Certificates</div>
                <p className="training-module-desc">
                Complete required modules and exam to receive certificate
                </p>
            </div>

            <div className="training-section-title">🎯 What's Next?</div>
            <ul className="applicant-training-module-desc">
              <li>✅ Completed all modules and exam.</li>
              <li>🔍 Be reviewed for a trial hire opportunity.</li>
              <li>📘 Begin 2–4 weeks of Role-Specific training.</li>
              <li>💼 Receive a permanent offer with salary upon successful training completion.</li>
            </ul>

            <div className="training-section-title">📩 Questions?</div>
            <p className="applicant-training-module-desc">
              Reach out to us at <Link to="/support">Support Chat</Link> if you need help or have questions about the process.
            </p>
          </div>
        </div>
      </div>
      <hr />
      <Footer />
    </div>
  );
};

export default ApplicantTraining;
